// TODO 各componentはJobの新設計移行後に分割する

import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Close } from 'jbc-front/components/icons';
import { formatDateWithHour } from 'src/utils/Date';
import Loading from 'src/components/Loading';
import _ from 'lodash';
import styles from './JobStatus.scss';
import { useTranslation } from 'react-i18next';

export const AllJobStatus = ({ task, taskStyle, statusText, hideJobMessage }) => {
  const Success = ({ job, cssStyles, text, closeButton }) => (
    <React.Fragment>
      <div className={cssStyles.close} role="presentation" onClick={() => closeButton(job.id)}>
        <Close size={20} />
      </div>
      <ul className={cssStyles.list}>
        <JobSuccess key={job.id} statusText={text(job)} {...job} />
      </ul>
    </React.Fragment>
  );

  const Failed = ({ job, cssStyles, text, closeButton }) => (
    <React.Fragment>
      <div className={cssStyles.close} role="presentation" onClick={() => closeButton(job.id)}>
        <Close size={20} />
      </div>
      <ul className={cssStyles.list}>
        <JobFailed key={job.id} statusText={text(job)} {...job} />
      </ul>
    </React.Fragment>
  );

  const InProgress = ({ job, cssStyles, text }) => (
    <React.Fragment>
      <ul className={cssStyles.list}>
        <JobInProgress key={job.id} statusText={text(job)} {...job} />
      </ul>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {!isEmpty(task) && (
        <div className={taskStyle(task, styles)}>
          <div className={styles.inner}>
            {task.status === 'success' && (
              <Success job={task} cssStyles={styles} text={statusText} closeButton={hideJobMessage} />
            )}
            {task.status === 'failed' && (
              <Failed job={task} cssStyles={styles} text={statusText} closeButton={hideJobMessage} />
            )}
            {(task.status === 'in_progress' || task.status === 'waiting') && (
              <InProgress job={task} cssStyles={styles} text={statusText} />
            )}
          </div>
        </div>
      )}
      {isEmpty(task) && null}
    </React.Fragment>
  );
};

export const JobSuccess = ({ statusText, name, startedAt, endedAt }) => {
  const { t } = useTranslation();
  return (
    <li>
      <p className={styles.title}>
        {name}
        {statusText}
      </p>
      <div className={styles.dates}>
        <dl>
          <dt>{t('components.JobStatus.AllJobStatus.executed_date')}：</dt>
          <dd>{formatDateWithHour(startedAt)}</dd>
        </dl>
        <dl>
          <dt>{t('components.JobStatus.AllJobStatus.completed_date')}：</dt>
          <dd>{formatDateWithHour(endedAt)}</dd>
        </dl>
      </div>
    </li>
  );
};

export const JobFailed = ({ name, startedAt, endedAt, messages, statusText }) => {
  const { t } = useTranslation();
  return (
    <li>
      <p className={styles.title}>
        {name}
        {statusText}
      </p>
      <div className={styles.dates}>
        <dl>
          <dt>{t('components.JobStatus.AllJobStatus.executed_date')}：</dt>
          <dd>{formatDateWithHour(startedAt)}</dd>
        </dl>
        <dl>
          <dt>{t('components.JobStatus.AllJobStatus.completed_date')}：</dt>
          <dd>{formatDateWithHour(endedAt)}</dd>
        </dl>
      </div>
      <ul>{!_.isEmpty(messages) && JSON.parse(messages).map(msg => <li key={msg}>{msg}</li>)}</ul>
    </li>
  );
};

export const JobInProgress = ({ statusText, name, startedAt }) => {
  const { t } = useTranslation();
  return (
    <li>
      <div className={styles.waiting}>
        <div className={styles.loading}>
          <Loading />
        </div>
        <div className={styles.info}>
          <p className={styles.title}>
            {name}
            {statusText}
          </p>
          <div className={styles.dates}>
            <dl>
              <dt>{t('components.JobStatus.AllJobStatus.executed_date')}：</dt>
              <dd>{formatDateWithHour(startedAt)}</dd>
            </dl>
          </div>
        </div>
      </div>
    </li>
  );
};
